import { render, staticRenderFns } from "./InvoicingView.vue?vue&type=template&id=38c43590"
import script from "./InvoicingView.vue?vue&type=script&lang=js"
export * from "./InvoicingView.vue?vue&type=script&lang=js"
import style0 from "./InvoicingView.vue?vue&type=style&index=0&id=38c43590&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports